import { Injectable } from "@angular/core";
import { GridLayoutService } from "@irb-common/interfaces/grid-layout.service";
import { DeleteSecuritiesErrorDialogComponent } from "./delete-securities-error-dialog.component";

@Injectable({
  providedIn: "root",
})
export class DeleteSecurityErrorModelContainsGridLayoutService implements GridLayoutService<DeleteSecuritiesErrorDialogComponent> {
  constructor() {}

  getFrameworkComponents() {
    return {};
  }

  getColumnDefs() {
    return [
      {
        headerName: "Symbol",
        field: "symbol",
        maxWidth: 100
      },
      {
        headerName: "Reason",
        field: "reason",
        cellRenderer: "cellRendererFormatter",
        cellRendererParams: {
          text: (params: any) => {
            return params.value != null && params.value.length > 0;
          },
        },
        flex: 1
      },
      {
        headerName: "Location",
        field: "location",
        cellRenderer: "cellRendererFormatter",
        cellRendererParams: {
          text: (params: any) => {
            return params.value != null && params.value.length > 0;
          },
        },
        maxWidth: 125
      },
    ];
  }
}
